import React from "react";
import AthleteSearch from "../../pages/common/athletes/AthleteSearch";
import SimilarAthleteFiltersDropdown from "./SimilarAthleteFiltersDropdown";
import CompareAthleteResultsList from "./CompareAthleteResultsList";

export default function CompareAthleteSearchPanel({
  showSimilarDropdown,
  setShowSimilarDropdown,
  onOpenSimilarDropdown,
  similarFilters,
  toggleSimilarFilter,
  onApplySimilarFilters,
  handleSearch,
  searchAthleteRef,
  loading,
  shouldSearchAfterLoad,
  adjustedHeight,
  visibleAthletes,
  hasAppliedSimilarFilters,
  observerTarget,
  isLoadingMore,
  hasMore,
  onSelectAthlete,
}) {
  return (
    <div id="search-athlete" className="gap-4">
      <div className="p-4 rounded-lg border-gray-300 max-h-[80vh]">
        <div className="flex items-center justify-between mb-3 pr-10">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
            Compare to another player
          </h2>

          <div className="flex items-center gap-4">
            <SimilarAthleteFiltersDropdown
              open={showSimilarDropdown}
              setOpen={setShowSimilarDropdown}
              onOpen={onOpenSimilarDropdown}
              filters={similarFilters}
              onToggle={toggleSimilarFilter}
              onApply={onApplySimilarFilters}
            />
          </div>
        </div>

        <AthleteSearch
          handleSearch={handleSearch}
          reference={searchAthleteRef}
        />

        <CompareAthleteResultsList
          loading={loading}
          shouldSearchAfterLoad={shouldSearchAfterLoad}
          adjustedHeight={adjustedHeight}
          athletes={visibleAthletes}
          hasAppliedSimilarFilters={hasAppliedSimilarFilters}
          observerTarget={observerTarget}
          isLoadingMore={isLoadingMore}
          hasMore={hasMore}
          onSelectAthlete={onSelectAthlete}
        />
      </div>
    </div>
  );
}
